"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var typescript_fsa_1 = require("typescript-fsa");
var typescript_fsa_reducers_1 = require("typescript-fsa-reducers");
var CommitError = /** @class */ (function (_super) {
    __extends(CommitError, _super);
    function CommitError(error) {
        if (error === void 0) { error = true; }
        var _this = _super.call(this, 'Commit Error') || this;
        _this.error = undefined;
        _this.name = 'CommitError';
        _this.error = error;
        _this.name = 'CommitError';
        return _this;
    }
    return CommitError;
}(Error));
exports.CommitError = CommitError;
var getProp = function (object, path, defaultValue) {
    if (defaultValue === void 0) { defaultValue = undefined; }
    if (path === undefined || path === null) {
        return defaultValue;
    }
    var pathArray = path;
    var val = pathArray.reduce(function (o, x) {
        return typeof o === 'undefined' || o === null ? defaultValue : o[x];
    }, object);
    if (typeof val === 'undefined' || val === null) {
        return defaultValue;
    }
    return val;
};
var setPropInObject = function (originObject, path, iteration, setObject) {
    var _a;
    if (path[iteration]) {
        return __assign({}, originObject, (_a = {}, _a[path[iteration]] = path[iteration + 1]
            ? __assign({}, setPropInObject(getProp(originObject, [path[iteration]], {}), path, iteration + 1, setObject)) : setObject, _a));
    }
};
var setProp = function (originObject, path, setObject) {
    var result = setPropInObject(originObject, path, 0, setObject);
    return result;
};
var actionCreator = typescript_fsa_1.default('@@redux-list');
exports.initialize = actionCreator('INITIALIZE');
exports.setParams = actionCreator('PARAMS_SET');
var commitActions = actionCreator.async('COMMIT');
var isCommitError = function (error) {
    return error && error.name === CommitError.name;
};
var commitAsync = function (payload) {
    return function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var key, result, commitError_1, error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = exports.getListParametersSerialized(payload.listName)(getState());
                    dispatch(commitActions.started({
                        listName: payload.listName,
                        key: key,
                    }));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, payload.load()];
                case 2:
                    result = _a.sent();
                    dispatch(commitActions.done({
                        params: {
                            listName: payload.listName,
                            key: key,
                        },
                        result: result,
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    commitError_1 = _a.sent();
                    error = isCommitError(commitError_1) ? commitError_1 : undefined;
                    if (error) {
                        dispatch(commitActions.failed({
                            params: {
                                listName: payload.listName,
                                key: key,
                            },
                            error: error.error,
                        }));
                        return [2 /*return*/, error];
                    }
                    else {
                        throw commitError_1;
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
exports.commit = {
    action: commitAsync,
    async: commitActions,
};
var INITIAL_STATE = {};
var listReducer = typescript_fsa_reducers_1.reducerWithInitialState(INITIAL_STATE)
    .case(exports.initialize, function (state, _a) {
    var listName = _a.listName, initialParams = _a.initialParams;
    return (__assign({}, setProp(state, [listName], {
        id: listName,
        parameters: initialParams || {},
        byParameters: {},
    })));
})
    .case(exports.setParams, function (state, payload) { return (__assign({}, setProp(state, [payload.listName, 'parameters'], payload.parameters))); })
    .case(exports.commit.async.started, function (state, _a) {
    var key = _a.key, listName = _a.listName;
    return (__assign({}, setProp(state, [listName, 'byParameters', key], __assign({}, getProp(state, [listName, 'byParameters', key], {}), { isCommitting: true }))));
})
    .case(exports.commit.async.failed, function (state, _a) {
    var _b = _a.params, key = _b.key, listName = _b.listName, error = _a.error;
    return (__assign({}, setProp(state, [listName, 'byParameters', key], {
        isCommitting: false,
        error: error,
    })));
})
    .case(exports.commit.async.done, function (state, _a) {
    var _b = _a.params, key = _b.key, listName = _b.listName, result = _a.result;
    return (__assign({}, setProp(state, [listName, 'byParameters', key], {
        isCommitting: false,
        nextOffset: result.nextOffset,
        total: result.total,
        results: result.results,
        error: undefined,
    })));
});
exports.listReducer = listReducer;
var listsDomain = function (state) { return state.list; };
var listDomain = function (listName) {
    return reselect_1.createSelector(listsDomain, function (substate) {
        return substate[listName] || {};
    });
};
exports.getListParameters = function (listName) {
    return reselect_1.createSelector(listDomain(listName), function (substate) {
        return substate.parameters || {};
    });
};
exports.getListParametersSerialized = function (listName) {
    return reselect_1.createSelector(exports.getListParameters(listName), function (substate) {
        return Object.keys(substate)
            .sort()
            .map(function (param) {
            if (param) {
                return param + "=" + substate[param].toString();
            }
            return null;
        })
            .filter(function (v) { return v; })
            .join('&');
    });
};
var getListByParametersDomain = function (listName) {
    return reselect_1.createSelector(listDomain(listName), exports.getListParametersSerialized(listName), function (substate, key) {
        if (substate.byParameters) {
            return substate.byParameters[key];
        }
        return null;
    });
};
exports.getListResults = function (listName) {
    return reselect_1.createSelector(getListByParametersDomain(listName), function (substate) {
        return substate && substate.results;
    });
};
exports.isCommiting = function (listName) {
    return reselect_1.createSelector(getListByParametersDomain(listName), function (substate) {
        return substate && substate.isCommitting;
    });
};
exports.hasCommitFailed = function (listName) {
    return reselect_1.createSelector(getListByParametersDomain(listName), function (substate) {
        return !!(substate && substate.error);
    });
};
exports.getListTotal = function (listName) {
    return reselect_1.createSelector(getListByParametersDomain(listName), function (substate) {
        return substate && substate.total;
    });
};
exports.getListNextOffset = function (listName) {
    return reselect_1.createSelector(getListByParametersDomain(listName), function (substate) {
        return substate && substate.nextOffset;
    });
};
//# sourceMappingURL=ducks.js.map